module.exports = __webpack_public_path__ + "img/question.2a379d39.svg";